import { render, staticRenderFns } from "./LoanDetailsPage.vue?vue&type=template&id=a4c03860"
import script from "./LoanDetailsPage.vue?vue&type=script&lang=js"
export * from "./LoanDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports